import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthContext } from 'react-oauth2-code-pkce';
import { redirectToLogin } from '../services/auth/authRedirect';
import Loading from '../components/TFLoading';

/**
 * Handles OAuth errors by redirecting to login. Shows a loading screen while on the callback page.
 */
const OAuthErrorHandler: React.FC = () => {
  const stateError = '"state" value received from authentication server does no match client request';
  const callbackPath = '/auth/callback';
  const { pathname } = useLocation();
  const { error } = useContext(AuthContext);
  const isOnCallbackPage = pathname === callbackPath;

  // Redirect to login if state error is detected. Handles multi-tab race conditions.
  useEffect(() => {
    if (error && error.includes(stateError)) {
      redirectToLogin();
    }
  }, [error]);

  // Timeout if stuck on callback page. Handles multi-tab race conditions.
  useEffect(() => {
    if (isOnCallbackPage) {
      const timeout = setTimeout(() => {
        redirectToLogin();
      }, 5000);

      return () => clearTimeout(timeout);
    }
    return undefined;
  }, [isOnCallbackPage]);

  if (isOnCallbackPage) {
    return (
      <Loading loading />
    );
  }

  return null;
};

export default OAuthErrorHandler;

